import { createSlice } from '@reduxjs/toolkit'
import { getSkuLandingPageFiltersAsync } from 'src/services/costModelling/skuShouldCostWorkbench.services'

export const initialSelectedFilters = {
  vendorDetails: {
    vendorId: [],
    vendorName: [],
    vendorType: [],
    country: [],
  },
  skuProduct: {
    l1: [],
    l2: [],
    l3: [],
    variant: [],
    productType: [],
    htsCode: [],
  },
  uploadDetails: {
    uploadedFrom: null,
    uploadedTo: null,
    uploadedBy: [],
  },
  ltmSpend: [0, 0],
  isSimulation: null,
  ifa_shortlisting: null,
  po_eligible: null,
}
const initialState = {
  selected: initialSelectedFilters,
  options: {
    vendorId: [],
    vendorName: [],
    vendorType: [],
    country: [],
    l1: [],
    l2: [],
    l3: [],
    variant: [],
    productType: [],
    htsCode: [],
    uploadedBy: [],
    uploadedTo: null,
    uploadedFrom: null,
    skuPrimaryId: [],
    poCurrency: [],
    ltmSpend: { min_ltm_spend: 0, max_ltm_spend: 0 },
    skuSimulationCount: { all_skus: 0, without_simulation: 0, with_simulation: 0 },
  },
  loading: false,
}

export const skuLandingPageFiltersSlice = createSlice({
  name: 'sku-landing-page-filters-slice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSkuLandingPageFiltersAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(getSkuLandingPageFiltersAsync.fulfilled, (state, action) => {
        const {
          vendorId,
          vendorName,
          vendorType,
          country,
          l1,
          l2,
          l3,
          productType,
          htsCode,
          uploadedBy,
          skuPrimaryId,
          poCurrency,
          dateRange,
          ltmSpend,
          variant,
          skuSimulationCount,
          fetchOnlyTaxonomyFilter,
        } = action.payload.data
        state.options = fetchOnlyTaxonomyFilter
          ? {
              ...state.options,
              l1: l1 ?? [],
              l2: l2 ?? [],
              l3: l3 ?? [],
              variant: variant ?? [],
            }
          : {
              vendorId: vendorId ?? [],
              vendorName: vendorName ?? [],
              vendorType: vendorType ?? [],
              country: country ?? [],
              l1: l1 ?? [],
              l2: l2 ?? [],
              l3: l3 ?? [],
              variant: variant ?? [],
              productType: productType ?? [],
              htsCode: htsCode ?? [],
              uploadedFrom: dateRange?.min_date ?? null,
              uploadedTo: dateRange?.max_date ?? null,
              uploadedBy: uploadedBy ?? [],
              skuPrimaryId: skuPrimaryId ?? [],
              poCurrency: poCurrency ?? [],
              ltmSpend: ltmSpend ?? { min_ltm_spend: 0, max_ltm_spend: 0 },
              skuSimulationCount: skuSimulationCount ?? {
                all_skus: 0,
                without_simulation: 0,
                with_simulation: 0,
              },
            }
        state.loading = false
      })
      .addCase(getSkuLandingPageFiltersAsync.rejected, (state) => {
        state.loading = false
        state.options = initialState.options
      })
  },
  reducers: {
    setAppliedFilterSection: (state, action) => {
      state.selected = { ...action.payload }
    },
    setFiltersOptions: (state, action) => {
      state.options = { ...action.payload }
    },
    resetAppliedFilterSection: (state) => {
      state.selected = initialSelectedFilters
    },
  },
})

export const { setAppliedFilterSection, resetAppliedFilterSection, setFiltersOptions } =
  skuLandingPageFiltersSlice.actions

export default skuLandingPageFiltersSlice.reducer
